import React from "react";

import { styled } from "@styles/theme";
import Logo from "@icons/illustrations/logo";

import { Spacer } from "@components/common/Spacer";
import { Row, Col } from "@components/common/Grid";
import { Flex } from "@components/common/ResponsiveBox";
import { Text } from "@components/common/Text";
import { ForgotPasswordForm } from "@components/pages/account/ForgotPasswordForm";
import { BackButton } from "@components/common/BackBtn";
import { H2 } from "@components/common/Headings";

const Container = styled.div`
  width: 100%;
  overflow: hidden;
  min-height: 100vh;
  background-color: #ffffff;
  padding-bottom: ${(p) => p.theme.spacing.xxxg};
`;

const ForgotPassword = () => {
  return (
    <Container>
      <Flex
        mT={{ 0: "md", 2: "xxxg" }}
        mX="auto"
        maxW={1200}
        pX={{ 0: "md", 3: "none" }}
      >
        <Logo fill="dark" />
        <Row>
          <Col mX="auto" mT="sm" size={{ 0: 12, 2: 5 }}>
            <BackButton href="/">Back</BackButton>
            <Spacer size="xg" />
            <H2 style={{ textAlign: "center" }} weight="normal">
              Forgot your password?
            </H2>
            <Spacer size="xs" />
            <Text align="center" colorWeight="200">
              We'll help you reset it.
            </Text>
            <Spacer size="xg" />
            <ForgotPasswordForm />
          </Col>
        </Row>
      </Flex>
    </Container>
  );
};

ForgotPassword.public = true;

export default ForgotPassword;
